import { UnityBridge } from "@Context/common/general/context";
import { AnalyticsEvents, Preferences } from "@Enums/index";
import { useAnalytics } from "@hooks/common/analytics/use-analytics";
import useUserPreferences from "@hooks/common/user/use-user-preferences";
import useI18n, { SUPPORTED_LANGUAGES } from "@i18n";
import i18next from "@i18next";
import { useEffect, useState } from "react";

export const useLanguageSettings = () => {
  const { updatePreferences, updating: isLoading } = useUserPreferences();
  const { i18n, locale, setLocale } = useI18n();
  const [currentLocale, setCurrentLocale] = useState(locale);
  const { track } = useAnalytics();

  const handleLanguageChange = (newLocale: string) => {
    setCurrentLocale(newLocale);

    if (newLocale === locale) return;

    updatePreferences([{ id: Preferences.locale, value: newLocale }], {
      onSuccess: () => {
        setLocale(newLocale);
        i18next.changeLanguage(newLocale);

        UnityBridge.dispatchWebEvent({
          type: UnityBridge.OutgoingWebEvents.SetPreferences,
          payload: {
            [Preferences.locale]: newLocale,
          },
        });

        track(AnalyticsEvents.selected_language, { locale: newLocale });
      },
      onError: () => {
        setCurrentLocale(locale);
      },
    });
  };

  const handleLocaleChange = (newLocale: string) => {
    if (isLoading || newLocale === currentLocale) return;
    handleLanguageChange(newLocale);
  };

  useEffect(() => {
    handleLanguageChange(locale);
  }, [locale]);

  return {
    currentLocale,
    isLoading,
    supportedLanguages: SUPPORTED_LANGUAGES,
    handleLocaleChange,
    i18n,
  };
};
